import { Component } from '@angular/core';

@Component({
    selector: 'admin-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.css']
})
/**
 * Component to display the group.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class GroupComponent {

}



// WEBPACK FOOTER //
// ./src/app/admin/groups/group.component.ts